import { Dialog } from "primereact/dialog";
import React, { useEffect } from "react";
import "../Dialog.css";

import useAlert from "../../../hooks/useAlert";
import { useForm } from "antd/lib/form/Form";
import { Col, Form, Row, Switch } from "antd";
import { InputText } from "primereact/inputtext";
import { FiSave } from "react-icons/fi";
import { SaveMSTAsset } from "../../../Services/MstAssetService";

interface Props {
  dialogHeader: string;
  formData: any;
  tableData?: any;
  setTableData?: (items: any) => void;
  tableComfirmDialog?: boolean;
  setTableComfirmDialog?: (bool: boolean) => void;
  mainDialogVisible?: boolean;
  toggleMainDialog: (state: boolean, action: string) => void;
  setMainLoading?: (bool: boolean) => void;
}

export const MstAssetDialog = (props: Props) => {
  const { toggleAlert } = useAlert();
  const [form] = useForm();

  useEffect(() => {
    form.setFieldsValue(props.formData);
  }, [props.formData]);

  const handleSubmit = async (values: any) => {
    if (props.setMainLoading !== undefined) {
      props.setMainLoading(true);
    }
    const res = await SaveMSTAsset(values);
    if (res) {
      props.toggleMainDialog(false, "save");
      form.resetFields();
      toggleAlert({
        type: "success",
        message: "Success",
        description: "Asset saved successfully",
      });
    } else {
      toggleAlert({
        type: "error",
        message: "Error",
        description: "Asset not saved",
      });
    }
    if (props.setMainLoading !== undefined) {
      props.setMainLoading(false);
    }
  };

  return (
    <Dialog
      visible={props.mainDialogVisible}
      breakpoints={{}}
      style={{ width: "70vw", borderRadius: "16px" }}
      header={props.dialogHeader}
      modal
      className="p-fluid"
      onHide={() => {
        form.resetFields();
        props.toggleMainDialog(false, "close");
      }}
      draggable={false}
      closable={false}
      blockScroll
    >
      <Form form={form} name="MstAssetForm" onFinish={handleSubmit}>
        <Form.Item name="Id" hidden />
        <Row justify="space-between" gutter={10}>
          <Col span={12}>
            <Form.Item
              label="GL Account Code"
              name="GLAccountCode"
              initialValue={""}
              rules={[
                { required: true, message: "Please enter GL Account Code" },
              ]}
            >
              <InputText maxLength={50} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Asset Class"
              name="AssetClass"
              initialValue={""}
              rules={[{ required: true, message: "Please enter Asset Class" }]}
            >
              <InputText maxLength={50} />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="space-between" gutter={10}>
          <Col span={12}>
            <Form.Item
              label="Category Code"
              name="CategoryCode"
              initialValue={""}
              rules={[
                { required: true, message: "Please enter Category Code" },
              ]}
            >
              <InputText maxLength={12} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Asset Code"
              name="AssetCode"
              initialValue={""}
              rules={[{ required: true, message: "Please enter Asset Code" }]}
            >
              <InputText maxLength={50} />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="space-between" gutter={10}>
          <Col span={24}>
            <Form.Item
              label="Asset Name"
              name="AssetName"
              initialValue={""}
              rules={[{ required: true, message: "Please enter Asset Name" }]}
            >
              <InputText />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="space-between" gutter={10}>
          <Col span={12}>
            <Form.Item
              label="Is Active"
              name="IsActive"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </Col>
        </Row>
        <div className="footer-dialog">
          <button
            onClick={() => {
              props.toggleMainDialog(false, "close");
            }}
            className="button-cancle"
          >
            Close
          </button>

          <button className="button-save" type="submit">
            <FiSave />
            Save
          </button>
        </div>
      </Form>
    </Dialog>
  );
};
